import editorialMetadataJson from '@/content/editorial-metadata.json';

export type EditorialCitation = {
  label: string;
  href: string;
  publisher?: string;
  published?: string;
};

export type EditorialMetadata = {
  canonicalPath: string;
  author: string;
  reviewer: string;
  lastReviewed: string;
  citations: EditorialCitation[];
};

const editorialMetadata = editorialMetadataJson as EditorialMetadata[];

export const editorialMetadataByPath: Record<string, EditorialMetadata> = Object.fromEntries(
  editorialMetadata.map((entry) => [entry.canonicalPath, entry])
);

function normalizePath(pathname: string): string {
  if (pathname === '/index.html' || pathname === '/index') {
    return '/';
  }

  if (pathname.endsWith('.html')) {
    return pathname.slice(0, -'.html'.length);
  }

  return pathname;
}

export function getEditorialMetadata(pathname: string): EditorialMetadata | null {
  const normalized = normalizePath(pathname);
  return editorialMetadataByPath[normalized] ?? null;
}
